import { Component, computed, ElementRef, OnInit, Signal, ViewChild } from '@angular/core';
import { UserManagerService } from '@app/managers';
import { Machine } from '@app/dtos';
import { Router } from '@angular/router';
import { ParametersService } from '@app/components/parameters/parameters.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { toSignal } from '@angular/core/rxjs-interop';
import { Optional } from '@it-entwicklung/ngx-poettinger-components';
import { AuthService } from '@auth0/auth0-angular';

@Component({
    selector: 'app-mymachines-overview',
    templateUrl: './mymachines-overview.component.html',
    styleUrls: ['./mymachines-overview.component.scss'],
    standalone: false
})
export class MyMachinesOverviewComponent implements OnInit {

    userId: Signal<Optional<string>> = computed(() => this.parameterService.userSignal()?.id);

    userMachinesResource = this.userManager.userMachinesResource;

    @ViewChild('ebeneMachineAdd') ebeneMachineAdd: ElementRef;
    isLoggedIn = toSignal(this.authService.isAuthenticated$, { initialValue: false });
    showMachineAdd = false;
    constructor(
        private readonly userManager: UserManagerService,
        private readonly router: Router,
        private readonly parameterService: ParametersService,
        private readonly authService: AuthService
    ) { }

    ngOnInit() {
        this.parameterService.nextRouteAfterLogin = this.router.url;
        this.userMachinesResource.reload();
    }

    onClickMachine(myMachine: Machine) {
        this.router.navigate(['/machine-details/', myMachine.machineNumber]);
        this.parameterService.setMyMachine(myMachine);
    }

    onClickAddMachine() {
        this.showMachineAdd = !this.showMachineAdd;
        const waitForElementToShow = setInterval(() => {
            this.ebeneMachineAdd.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            clearInterval(waitForElementToShow);
        }, 100);
    }

    dropMachine(event: CdkDragDrop<Machine[]>) {
        const machines = this.userMachinesResource.value();
        moveItemInArray(machines, event.previousIndex, event.currentIndex);

        const lowerBound = Math.min(event.previousIndex, event.currentIndex);
        const upperBound = Math.max(event.previousIndex, event.currentIndex);
        if (lowerBound === upperBound) {
            return;
        }
        // update current positions of elements
        for (let index = 0; index < machines.length; index++) {
            const machine = machines[index];
            machine.sort = index;
            this.userManager.updateUserMachine(machine.machineNumber, {
                sort: machine.sort,
                userDefinedName: machine.userDefinedName
            }).subscribe();
        }
        this.userMachinesResource.set(machines);
    }
}
